var _defs, _polygon, _text, _text2, _rect, _polygon2, _polygon3, _polygon4, _rect2, _polygon5, _polygon6, _rect3, _polygon7, _rect4, _polygon8, _rect5, _polygon9, _rect6, _line, _line2, _text3, _rect7, _rect8, _text4, _rect9, _rect10, _rect11, _rect12, _line3, _rect13, _rect14, _rect15, _text5, _rect16, _text6, _rect17, _text7, _rect18, _text8, _rect19, _text9, _rect20, _text10, _rect21, _text11, _g, _g2, _g3, _g4, _g5, _rect22, _text12, _rect23, _text13, _rect24, _text14, _rect25, _text15, _rect26, _text16, _rect27, _text17, _rect28, _text18, _text19, _rect29, _text20, _text21, _text22, _text23, _rect30, _text24, _rect31, _text25, _text26, _text27, _text28, _text29, _text30, _text31, _text32, _text33, _text34, _rect32, _text35, _text36, _rect33, _rect34, _rect35, _rect36, _text37, _text38, _text39, _g6, _g7, _rect37, _text40, _g8, _g9, _g10, _g11, _rect38, _text41, _rect39, _text42, _rect40, _text43, _rect41, _text44, _g12, _rect42, _text45, _rect43, _text46, _rect44, _text47, _rect45, _text48, _rect46, _text49, _rect47, _text50, _g13, _rect48, _text51, _text52, _rect49, _rect50, _text53, _text54, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _g26, _g27, _g28, _text55, _rect51, _text56, _g29, _g30, _g31, _g32, _g33, _g34, _g35, _rect52, _text57, _rect53, _text58, _text59, _text60, _text61, _rect54, _text62, _rect55, _text63, _g36, _rect56, _rect57, _text64, _text65, _rect58, _g37, _text66, _rect59, _g38, _g39, _g40, _polygon10, _polygon11, _polygon12, _rect60, _polygon13, _polygon14, _rect61, _polygon15, _rect62, _polygon16, _rect63, _polygon17, _text67, _g41, _g42, _g43, _rect64, _text68, _text69, _g44, _g45, _line4, _g46, _g47;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaterinfodagPlattegrond2026(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Laag_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1789.1 2234.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0, .st1, .st2, .st3 {\n        fill: none;\n      }\n\n      .st4 {\n        font-size: 36.3px;\n      }\n\n      .st4, .st5, .st6, .st7, .st8, .st9, .st10, .st11, .st12, .st13, .st14, .st15 {\n        font-family: MyriadPro-Bold, 'Myriad Pro';\n        font-weight: 700;\n      }\n\n      .st5 {\n        font-size: 17.7px;\n      }\n\n      .st5, .st6, .st7, .st9, .st10, .st11, .st12, .st13, .st14, .st15 {\n        fill: #1d1e1b;\n      }\n\n      .st16 {\n        fill: #b4e4ff;\n      }\n\n      .st16, .st17, .st18, .st19, .st20, .st21, .st22, .st23, .st24, .st25, .st26, .st27, .st1, .st2, .st28, .st29, .st30, .st31, .st3 {\n        stroke-miterlimit: 10;\n      }\n\n      .st16, .st17, .st18, .st19, .st20, .st21, .st22, .st23, .st24, .st25, .st26, .st27, .st2, .st28, .st29, .st30, .st31 {\n        stroke-width: 2px;\n      }\n\n      .st16, .st17, .st19, .st20, .st22, .st23, .st24, .st26, .st27, .st1, .st2, .st29, .st30, .st3 {\n        stroke: #000;\n      }\n\n      .st6 {\n        font-size: 17.4px;\n      }\n\n      .st7 {\n        font-size: 17.6px;\n      }\n\n      .st17 {\n        fill: #bcbcbc;\n      }\n\n      .st32 {\n        font-size: 15.5px;\n      }\n\n      .st32, .st33 {\n        font-family: MyriadPro-Semibold, 'Myriad Pro';\n        font-weight: 600;\n      }\n\n      .st18, .st19, .st25, .st30 {\n        fill-opacity: .2;\n      }\n\n      .st18, .st21 {\n        fill: #f4a67c;\n      }\n\n      .st18, .st21, .st25, .st28, .st31 {\n        stroke: #231f20;\n      }\n\n      .st19, .st22 {\n        fill: #ffea2a;\n      }\n\n      .st8 {\n        font-size: 24px;\n      }\n\n      .st9 {\n        font-size: 19.7px;\n      }\n\n      .st20 {\n        fill: #dcdcdc;\n      }\n\n      .st34 {\n        clip-path: url(#clippath-3);\n      }\n\n      .st35 {\n        clip-path: url(#clippath-4);\n      }\n\n      .st36 {\n        clip-path: url(#clippath-2);\n      }\n\n      .st37 {\n        clip-path: url(#clippath-7);\n      }\n\n      .st38 {\n        clip-path: url(#clippath-6);\n      }\n\n      .st39 {\n        clip-path: url(#clippath-5);\n      }\n\n      .st40 {\n        font-family: MyriadPro-Regular, 'Myriad Pro';\n        font-size: 72px;\n      }\n\n      .st40, .st24 {\n        fill: #fff;\n      }\n\n      .st23 {\n        fill: #b2d8c8;\n      }\n\n      .st10 {\n        font-size: 20px;\n      }\n\n      .st11 {\n        font-size: 21.8px;\n      }\n\n      .st12 {\n        font-size: 20.3px;\n      }\n\n      .st25, .st28 {\n        fill: #debf79;\n      }\n\n      .st26, .st30 {\n        fill: #b0d9c9;\n      }\n\n      .st27 {\n        fill: #e7e8ba;\n      }\n\n      .st13 {\n        font-size: 12.1px;\n      }\n\n      .st33 {\n        font-size: 16.9px;\n      }\n\n      .st29 {\n        fill: #b9b8b8;\n      }\n\n      .st14 {\n        font-size: 24.7px;\n      }\n\n      .st31 {\n        fill: #967f66;\n      }\n\n      .st15 {\n        font-size: 24.8px;\n      }\n\n      .st3 {\n        stroke-width: 3px;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "1615.8 541.4 1673.1 484.4 1652.4 463.6 1611.1 422 1554.1 478.7 1553.8 479 1553.8 479 1615.8 541.4"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "5187.7 584.6 5245 527.7 5224.4 506.9 5183 465.3 5126 522 5125.7 522.3 5125.7 522.3 5187.7 584.6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 5145,
    y: 481,
    width: 80.8,
    height: 88,
    transform: "translate(1139 3809.8) rotate(-44.9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "4713.2 1318.3 4812.7 1318.5 4812.8 1282.4 4813 1210.2 4714 1209.9 4713.5 1209.9 4713.5 1209.9 4713.2 1318.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 4708.9,
    y: 1214.5,
    width: 108.3,
    height: 99.5,
    transform: "translate(3486.4 6024) rotate(-89.9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "5108.1 1318.3 5207.7 1318.5 5207.8 1282.4 5207.9 1210.2 5108.9 1209.9 5108.5 1209.9 5108.4 1209.9 5108.1 1318.3"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 5103.9,
    y: 1214.5,
    width: 108.3,
    height: 99.5,
    transform: "translate(3880.4 6419) rotate(-89.9)"
  })))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st28",
    points: "22.2 1751.2 22.2 2225.9 1362.2 2225.9 1362.2 1940.3 1361.8 1751.2 22.2 1751.2"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "st40",
    transform: "translate(522.9 -394.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20 Pixel = 1 meter"), /*#__PURE__*/React.createElement("tspan", {
    x: -220,
    y: 86.4
  }, "Zaal is 70 meter breed, 87 lengte"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "st40",
    transform: "translate(1798.3 -394.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "52 zijn klaar"), /*#__PURE__*/React.createElement("tspan", {
    x: -127.2,
    y: 86.4
  }, "54 kolommen nodig"), /*#__PURE__*/React.createElement("tspan", {
    x: -142.8,
    y: 172.8
  }, "7 worden bijgemaakt"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st27",
    x: 44.3,
    y: 572.3,
    width: 97.5,
    height: 112.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "217.1 258.1 206.8 246.6 196.5 235.2 217.1 235.2 217.1 258.1"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "217.1 258.1 206.8 246.6 196.5 235.2 217.1 235.2 217.1 258.1"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "176.6 372.4 166.3 361 156 349.6 176.6 349.6 176.6 372.4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 121.8,
    y: 110.2,
    width: 280,
    height: 240
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "332.3 258.1 322.1 246.6 311.8 235.2 332.3 235.2 332.3 258.1"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "460.1 372.4 449.9 361 439.6 349.6 460.1 349.6 460.1 372.4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 401.8,
    y: 110.2,
    width: 280,
    height: 240
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "617 258.1 606.7 246.6 596.5 235.2 617 235.2 617 258.1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    x: 821.7,
    y: 110.2,
    width: 60,
    height: 240
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "724.2 372.4 713.9 361 703.6 349.6 724.2 349.6 724.2 372.4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 681.7,
    y: 110.2,
    width: 140,
    height: 240
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "759.1 258.1 748.8 246.6 738.5 235.2 759.1 235.2 759.1 258.1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "st27",
    x: 21.8,
    y: 684.4,
    width: 42,
    height: 102
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 961.8,
    y1: 1430,
    x2: 961.8,
    y2: 880.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 961.7,
    y1: 603.5,
    x2: 961.7,
    y2: 30
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    className: "st6",
    transform: "translate(37.7 703.3) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INGANG"))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "st31",
    x: 141.8,
    y: 544,
    width: 20,
    height: 140
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "st31",
    x: 141.8,
    y: 786.8,
    width: 20,
    height: 143.1
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    className: "st13",
    transform: "translate(55.9 624.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "REGISTRATIE/"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.7,
    y: 14.5
  }, "INFORMATIE"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.4,
    y: 29.1
  }, "BALIE"))), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-2",
    className: "st30",
    x: 282.8,
    y: 970.2,
    width: 80,
    height: 60
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-4",
    className: "st30",
    x: 441.9,
    y: 970.2,
    width: 80,
    height: 60
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-5",
    className: "st26",
    x: 521.8,
    y: 970.2,
    width: 80,
    height: 60
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    className: "st29",
    x: 682.5,
    y: 645.1,
    width: 200,
    height: 100
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 1761.8,
    y1: 29.8,
    x2: 1761.8,
    y2: 976
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 962.3,
    y: 1030.2,
    width: 800,
    height: 400
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 962.3,
    y: 30.2,
    width: 800,
    height: 400
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-127",
    className: "st25",
    x: 162.8,
    y: 859.9,
    width: 40,
    height: 60
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(191.7 912.2) rotate(-90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "128"))), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-128",
    className: "st25",
    x: 1075.1,
    y: 971.6,
    width: 60,
    height: 40
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1084.5 998.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "130"))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-1281",
    "data-name": "stand-128",
    className: "st25",
    x: 1135.1,
    y: 971.6,
    width: 60,
    height: 40
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1144.5 998.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "131"))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-1282",
    "data-name": "stand-128",
    className: "st19",
    x: 1364.5,
    y: 971.6,
    width: 60,
    height: 40
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1373.9 998.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "138"))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-126",
    className: "st25",
    x: 162.8,
    y: 799.5,
    width: 40,
    height: 60
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(191.7 850.7) rotate(-90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "127"))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-1271",
    "data-name": "stand-127",
    className: "st28",
    x: 162.8,
    y: 616.7,
    width: 40,
    height: 60
  })), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(191.7 669) rotate(-90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "106"))), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-1261",
    "data-name": "stand-126",
    className: "st25",
    x: 162.8,
    y: 556.3,
    width: 40,
    height: 60
  })), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(191.7 607.5) rotate(-90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "105"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-114",
    className: "st28",
    x: 262.8,
    y: 786.8,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(272.2 815.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "117")))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-119",
    className: "st25",
    x: 262.8,
    y: 826.8,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(272.2 854.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "122")))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-108",
    className: "st25",
    x: 582.8,
    y: 603.5,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(592.2 630.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "111")))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-113",
    className: "st28",
    x: 582.8,
    y: 643.5,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(592.2 670.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "116")))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-1",
    className: "st26",
    x: 202.8,
    y: 970.2,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(234.6 1008.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")))), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-14",
    className: "st30",
    x: 761.9,
    y: 463.5,
    width: 80,
    height: 60
  })), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(788.2 500.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "17"))), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-15",
    className: "st30",
    x: 681.9,
    y: 463.5,
    width: 80,
    height: 60
  })), _text13 || (_text13 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(708.2 500.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18"))), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-16",
    className: "st30",
    x: 601.8,
    y: 463.5,
    width: 80,
    height: 60
  })), _text14 || (_text14 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(628.1 500.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "19"))), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-17",
    className: "st30",
    x: 521.8,
    y: 463.5,
    width: 80,
    height: 60
  })), _text15 || (_text15 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(548.1 500.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20"))), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-171",
    "data-name": "stand-17",
    className: "st30",
    x: 441.9,
    y: 463.5,
    width: 80,
    height: 60
  })), _text16 || (_text16 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(468.2 500.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "21"))), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-161",
    "data-name": "stand-16",
    className: "st30",
    x: 1012.4,
    y: 719.9,
    width: 80,
    height: 60
  })), _text17 || (_text17 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1038.7 757.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "23"))), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-172",
    "data-name": "stand-17",
    className: "st30",
    x: 1012.4,
    y: 659.9,
    width: 80,
    height: 60
  })), _text18 || (_text18 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1038.7 697.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "22"))), _text19 || (_text19 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(315.9 1008.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2"))), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-3",
    className: "st30",
    x: 362.8,
    y: 970.2,
    width: 80,
    height: 60
  })), _text20 || (_text20 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(395.9 1008.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3"))), _text21 || (_text21 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(475 1008.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4"))), _text22 || (_text22 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(554.3 1008.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"))), _text23 || (_text23 = /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(742.1 700.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CATERING"))), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    className: "st29",
    x: 1474.7,
    y: 628.8,
    width: 115,
    height: 143.4
  })), _text24 || (_text24 = /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(1491.8 705.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CATERING"))), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    className: "st23",
    x: 22,
    y: 1447.2,
    width: 1130.9,
    height: 294.6
  })), _text25 || (_text25 = /*#__PURE__*/React.createElement("text", {
    className: "st15",
    transform: "translate(57.4 1492)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "STANDPLAATS"))), _text26 || (_text26 = /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(55.6 1536.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26.2
  }, "2."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52.4
  }, "3."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78.6
  }, "4."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104.9
  }, "5."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 131.1
  }, "6."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 157.3
  }, "7."))), _text27 || (_text27 = /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(87.2 1536.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CATEC BV"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104.9
  }, "OBSERVATOR INSTRUMENTS"))), _text28 || (_text28 = /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(397.1 1511.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26.2
  }, "9."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52.4
  }, "10."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78.6
  }, "11."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104.9
  }, "12."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 131.1
  }, "13."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 157.3
  }, "14."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 183.5
  }, "15."))), _text29 || (_text29 = /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(457.5 1510.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "HYDROLOGIC BV"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26.2
  }, "SWECO"), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 157.3
  }, "RIJKSWATERSTAAT"))), _text30 || (_text30 = /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(742.1 1510.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26.2
  }, "17."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52.4
  }, "18."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78.6
  }, "19."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104.9
  }, "20."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 131.1
  }, "21."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 157.3
  }, "22."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 183.5
  }, "23."))), _text31 || (_text31 = /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(790.8 1510.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "KYL B.V."))), _text32 || (_text32 = /*#__PURE__*/React.createElement("text", {
    className: "st15",
    transform: "translate(45.7 1792)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "BANNERSTAND"))), _text33 || (_text33 = /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(43.8 1826.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "101."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26.2
  }, "102."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52.4
  }, "103."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78.6
  }, "104."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104.9
  }, "105."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 131.1
  }, "106."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 157.3
  }, "107."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 183.5
  }, "108."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 209.7
  }, "109."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 235.9
  }, "110."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 262.1
  }, "111."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 288.3
  }, "112."))), _text34 || (_text34 = /*#__PURE__*/React.createElement("text", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 104.6,
    y: 1957.4
  }, "GEOMETIUS"))), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    className: "st21",
    x: 1369.4,
    y: 1751.2,
    width: 392.4,
    height: 474.7
  })), _text35 || (_text35 = /*#__PURE__*/React.createElement("text", {
    className: "st15",
    transform: "translate(1411.3 1801.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRAATTAFEL"))), _text36 || (_text36 = /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(1412.6 1841.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "201."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26.2
  }, "202."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52.4
  }, "203."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78.6
  }, "204."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104.9
  }, "205."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 131.1
  }, "206."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 157.3
  }, "207."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 183.5
  }, "208."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 209.7
  }, "209."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 235.9
  }, "210."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 262.1
  }, "211."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 288.3
  }, "212."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 314.6
  }, "213."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 340.8
  }, "214."))), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-115",
    className: "st25",
    x: 342.8,
    y: 786.8,
    width: 60,
    height: 40
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-117",
    className: "st25",
    x: 502.8,
    y: 786.8,
    width: 60,
    height: 40
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-120",
    className: "st25",
    x: 342.8,
    y: 826.8,
    width: 60,
    height: 40
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-123",
    className: "st25",
    x: 582.8,
    y: 826,
    width: 60,
    height: 40
  })), _text37 || (_text37 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(352 815.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "118"))), _text38 || (_text38 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(352.2 854.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "123"))), _text39 || (_text39 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(512.7 815.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "120"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "stand-124"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st25",
    x: 502.8,
    y: 826.8,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(512.2 854.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "125")))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-118",
    className: "st25",
    x: 582.8,
    y: 786.8,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(592.2 814.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "121")))), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-106",
    className: "st25",
    x: 422.8,
    y: 603.5,
    width: 60,
    height: 40
  })), _text40 || (_text40 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(432.2 630.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "109"))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-111",
    className: "st25",
    x: 422.8,
    y: 643.5,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(432.2 670.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "114")))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-116",
    className: "st25",
    x: 422.8,
    y: 786.8,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(432.2 814.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "119")))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-206",
    className: "st19",
    x: 1304.5,
    y: 971.6,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1313.9 998.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "137")))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-2061",
    "data-name": "stand-206",
    className: "st25",
    x: 963.2,
    y: 880,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(975.9 889.4) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "129")))), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-1283",
    "data-name": "stand-128",
    className: "st19",
    x: 1482.1,
    y: 971.6,
    width: 60,
    height: 40
  })), _text41 || (_text41 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1491.6 998.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "140"))), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-1284",
    "data-name": "stand-128",
    className: "st19",
    x: 1543.1,
    y: 971.6,
    width: 60,
    height: 40
  })), _text42 || (_text42 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1552.5 998.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "141"))), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-1285",
    "data-name": "stand-128",
    className: "st19",
    x: 1602.2,
    y: 971.9,
    width: 60,
    height: 40
  })), _text43 || (_text43 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1611.6 999.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "142"))), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-1286",
    "data-name": "stand-128",
    className: "st19",
    x: 1669.5,
    y: 877.4,
    width: 40,
    height: 60
  })), _text44 || (_text44 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1682.2 886.8) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "143"))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-2062",
    "data-name": "stand-206",
    className: "st19",
    x: 1422.1,
    y: 971.6,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1431.5 998.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "139")))), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-1287",
    "data-name": "stand-128",
    className: "st25",
    x: 1669.5,
    y: 677.3,
    width: 40,
    height: 60
  })), _text45 || (_text45 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1682.2 686.7) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "134"))), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-1288",
    "data-name": "stand-128",
    className: "st25",
    x: 1669.5,
    y: 736.2,
    width: 40,
    height: 60
  })), _text46 || (_text46 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1682.3 745.6) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "133"))), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-1289",
    "data-name": "stand-128",
    className: "st25",
    x: 1669.5,
    y: 795.2,
    width: 40,
    height: 60
  })), _text47 || (_text47 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1682.2 804.6) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "132"))), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-12810",
    "data-name": "stand-128",
    className: "st25",
    x: 1669.5,
    y: 558.8,
    width: 40,
    height: 60
  })), _text48 || (_text48 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1682.3 568.2) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "136"))), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-12811",
    "data-name": "stand-128",
    className: "st25",
    x: 184,
    y: 463.6,
    width: 60,
    height: 40
  })), _text49 || (_text49 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(193.4 490.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "101"))), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-12812",
    "data-name": "stand-128",
    className: "st25",
    x: 244.9,
    y: 463.6,
    width: 60,
    height: 40
  })), _text50 || (_text50 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(254.3 490.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "102"))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-2063",
    "data-name": "stand-206",
    className: "st25",
    x: 1669.5,
    y: 618.4,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1682.3 627.8) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "135")))), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-121",
    className: "st25",
    x: 422.8,
    y: 826.8,
    width: 60,
    height: 40
  })), _text51 || (_text51 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(432.2 854.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "124"))), _text52 || (_text52 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(592.2 853.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "126"))), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-6",
    className: "st30",
    x: 601.8,
    y: 970.2,
    width: 80,
    height: 60
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-7",
    className: "st30",
    x: 681.8,
    y: 970.2,
    width: 80,
    height: 60
  })), _text53 || (_text53 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(634.9 1008.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6"))), _text54 || (_text54 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(714.3 1008.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7"))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "stand-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st26",
    x: 901.8,
    y: 880.1,
    width: 60,
    height: 80
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(924.9 927.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9")))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-301",
    className: "st18",
    x: 682.8,
    y: 786.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(686.1 812.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "201")))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-304",
    className: "st18",
    x: 682.8,
    y: 826.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(686.1 852.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "204")))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-302",
    className: "st18",
    x: 762.8,
    y: 786.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(766.1 812.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "202")))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-305",
    className: "st18",
    x: 762.8,
    y: 826.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(766.1 852.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "205")))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-303",
    className: "st18",
    x: 842.5,
    y: 786.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(845.8 812.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "203")))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-306",
    className: "st18",
    x: 842.5,
    y: 826.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(845.8 852.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "206")))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3031",
    "data-name": "stand-303",
    className: "st18",
    x: 1482.1,
    y: 849.5,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1485.5 875.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "213")))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3061",
    "data-name": "stand-306",
    className: "st18",
    x: 1522.1,
    y: 849.5,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1525.5 875.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "214")))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3032",
    "data-name": "stand-303",
    className: "st18",
    x: 1345.8,
    y: 849.5,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1349.2 875.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "211")))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3062",
    "data-name": "stand-306",
    className: "st18",
    x: 1385.8,
    y: 849.5,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1389.2 875.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "212")))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3033",
    "data-name": "stand-303",
    className: "st18",
    x: 1208.4,
    y: 849.5,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1211.7 875.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "209")))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3063",
    "data-name": "stand-306",
    className: "st18",
    x: 1248.4,
    y: 849.5,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1251.7 875.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "210")))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3034",
    "data-name": "stand-303",
    className: "st18",
    x: 1075.1,
    y: 849.5,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1078.4 875.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "207")))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3064",
    "data-name": "stand-306",
    className: "st18",
    x: 1115.1,
    y: 849.5,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(1118.4 875.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "208")))), _text55 || (_text55 = /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(1589.9 493.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PITCH"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.2,
    y: 21.2
  }, "THEATER "))), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-8",
    className: "st26",
    x: 761.8,
    y: 970.2,
    width: 80,
    height: 60
  })), _text56 || (_text56 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(794.3 1008.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8"))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-12",
    className: "st30",
    x: 1049.8,
    y: 431.1,
    width: 120,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1096 468.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "14")))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-11",
    className: "st30",
    x: 1169.8,
    y: 431.1,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1196 468.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "13")))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-111",
    "data-name": "stand-11",
    className: "st30",
    x: 962.4,
    y: 523.5,
    width: 60,
    height: 80
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(978.7 570.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "15")))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-10",
    className: "st30",
    x: 1249.8,
    y: 431,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1275.1 468.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "12")))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-101",
    "data-name": "stand-10",
    className: "st30",
    x: 1329.8,
    y: 431,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1355.1 468.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "11")))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-102",
    "data-name": "stand-10",
    className: "st30",
    x: 1409.8,
    y: 430.9,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(1435.1 468.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10")))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    x: 1169.8,
    y: 623.5,
    width: 200,
    height: 160
  }), /*#__PURE__*/React.createElement("text", {
    className: "st33",
    transform: "translate(1192.9 678)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ONTMOETINGSPLEIN"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.7,
    y: 20.3,
    xmlSpace: "preserve"
  }, "HET  WATERSCHAPSHUIS"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.4,
    y: 40.5
  }, "INFORMATIEHUIS WATER"), /*#__PURE__*/React.createElement("tspan", {
    x: 49.4,
    y: 60.8
  }, "STOWA")))), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-101",
    className: "st25",
    x: 304.9,
    y: 463.6,
    width: 60,
    height: 40
  })), _text57 || (_text57 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(314.3 490.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "103"))), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-102",
    className: "st25",
    x: 365.2,
    y: 463.5,
    width: 60,
    height: 40
  })), _text58 || (_text58 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(374.6 490.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "104"))), _text59 || (_text59 = /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(1035.7 1826.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "125."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26.2
  }, "126."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52.4
  }, "127."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78.6
  }, "128."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104.9
  }, "129."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 131.1
  }, "130."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 157.3
  }, "131."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 183.5
  }, "132."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 209.7
  }, "133."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 235.9
  }, "134."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 262.1
  }, "135."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 288.3
  }, "136."))), _text60 || (_text60 = /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(568.9 1826.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "113."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26.2
  }, "114."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52.4
  }, "115."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78.6
  }, "116."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104.9
  }, "117."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 131.1
  }, "118."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 157.3
  }, "119."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 183.5
  }, "120."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 209.7
  }, "121."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 235.9
  }, "122."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 262.1
  }, "123."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 288.3
  }, "124."))), _text61 || (_text61 = /*#__PURE__*/React.createElement("text", {
    className: "st11"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 633.4,
    y: 1905
  }, "TECHNOLUTION"), /*#__PURE__*/React.createElement("tspan", {
    x: 633.4,
    y: 1931.2
  }, "XXLLNC"))), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-13",
    className: "st26",
    x: 901.8,
    y: 523.5,
    width: 60,
    height: 80
  })), _text62 || (_text62 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(918.1 570.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16"))), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-107",
    className: "st25",
    x: 502.8,
    y: 603.5,
    width: 60,
    height: 40
  })), _text63 || (_text63 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(512.2 630.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "110"))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-112",
    className: "st25",
    x: 502.8,
    y: 643.5,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(512.2 670.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "115")))), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-105",
    className: "st25",
    x: 342.8,
    y: 603.5,
    width: 60,
    height: 40
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-110",
    className: "st25",
    x: 342.8,
    y: 643.5,
    width: 60,
    height: 40
  })), _text64 || (_text64 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(352 631.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "108"))), _text65 || (_text65 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(352.2 670.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "113"))), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    id: "stand-109",
    className: "st25",
    x: 262.8,
    y: 643.5,
    width: 60,
    height: 40
  })), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-104",
    className: "st25",
    x: 262.8,
    y: 603.5,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(272.2 630.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "107")))), _text66 || (_text66 = /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(272.2 670.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "112"))), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    id: "Omtrek_beide_hallen",
    className: "st2",
    x: 21.8,
    y: 30,
    width: 1740,
    height: 1400
  })), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 137.6,
    y: 192.1,
    width: 248.4,
    height: 76
  }), /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(203.8 237.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEXTER 11")))), _g39 || (_g39 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 417.6,
    y: 192.1,
    width: 248.4,
    height: 76
  }), /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(483.8 237.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEXTER 15")))), _g40 || (_g40 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 689.1,
    y: 192.1,
    width: 125.3,
    height: 76
  }), /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(707.1 222.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEXTER "), /*#__PURE__*/React.createElement("tspan", {
    x: 31.3,
    y: 28.8
  }, "19")))), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "217.1 1258.1 206.8 1246.7 196.5 1235.2 217.1 1235.2 217.1 1258.1"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "217.1 1258.1 206.8 1246.7 196.5 1235.2 217.1 1235.2 217.1 1258.1"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "188 1087.3 198.3 1098.7 208.5 1110.2 188 1110.2 188 1087.3"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 149.6,
    y: 1110.2,
    width: 280,
    height: 240
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "359.1 1258.1 348.8 1246.7 338.5 1235.2 359.1 1235.2 359.1 1258.1"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "473.2 1087.3 483.5 1098.7 493.8 1110.2 473.2 1110.2 473.2 1087.3"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 429.6,
    y: 1110.2,
    width: 280,
    height: 240
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "643.8 1258.1 633.5 1246.7 623.2 1235.2 643.8 1235.2 643.8 1258.1"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    x: 848.4,
    y: 1110.2,
    width: 60,
    height: 240
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "721.2 1087.3 731.5 1098.7 741.7 1110.2 721.2 1110.2 721.2 1087.3"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 709.6,
    y: 1110.2,
    width: 140,
    height: 240
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "785.8 1258.1 775.5 1246.7 765.2 1235.2 785.8 1235.2 785.8 1258.1"
  })), _text67 || (_text67 = /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(1195.1 1117.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PLENAIRE OPENING"))), _g41 || (_g41 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 165.4,
    y: 1192.2,
    width: 248.4,
    height: 76
  }), /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(231.5 1237.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEXTER 22")))), _g42 || (_g42 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 445.4,
    y: 1192.2,
    width: 248.4,
    height: 76
  }), /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(511.5 1237.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEXTER 26")))), _g43 || (_g43 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 717.2,
    y: 1192.2,
    width: 125.3,
    height: 76
  }), /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(735.2 1222.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEXTER "), /*#__PURE__*/React.createElement("tspan", {
    x: 31.3,
    y: 28.8
  }, "30")))), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    className: "st22",
    x: 1163,
    y: 1448.6,
    width: 598.8,
    height: 293.2
  })), _text68 || (_text68 = /*#__PURE__*/React.createElement("text", {
    className: "st11",
    transform: "translate(1185.5 1536.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "137."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 26.2
  }, "138."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 52.4
  }, "139."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 78.6
  }, "140."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 104.9
  }, "141."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 131.1
  }, "142."), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 157.3
  }, "143."))), _text69 || (_text69 = /*#__PURE__*/React.createElement("text", {
    className: "st12",
    transform: "translate(1184.1 1478.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "KENNISCENTRUM MICROSOFT &amp; STRATEGISCH "), /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 24.4
  }, "LEVERANCIERSMANAGEMENT"))), _g44 || (_g44 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 38.3,
    y1: 413.5,
    x2: 80.2,
    y2: 413.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.2 423.5 23.9 413.5 41.2 403.5 41.2 423.5"
  }))), _g45 || (_g45 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 1254.4,
    y1: 1015.2,
    x2: 1254.4,
    y2: 973.2
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1264.4 1012.3 1254.4 1029.5 1244.5 1012.3 1264.4 1012.3"
  }))), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 32.6,
    y1: 411.7,
    x2: 34,
    y2: 411.7
  })), _g46 || (_g46 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M96,408.3c-.8.3-2.3.7-3.9.7s-3.6-.5-4.7-1.6c-1-.9-1.6-2.3-1.6-3.8,0-3.2,2.5-5.6,6.6-5.6s2.7.3,3.3.6l-.5,1.6c-.7-.3-1.5-.5-2.9-.5-2.6,0-4.3,1.5-4.3,3.8s1.6,3.9,4.2,3.9,1.5-.1,1.8-.3v-2.6h-2.1v-1.6h4.2v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103,408.9v-.9h-.2c-.5.6-1.4,1.1-2.5,1.1-1.7,0-2.6-1.2-2.6-2.3,0-2,1.8-3,5-3h0c0-.5-.2-1.5-1.7-1.5s-1.7.3-2.3.6l-.4-1.3c.7-.4,1.7-.7,3-.7,2.7,0,3.4,1.6,3.4,3.4v2.7c0,.7,0,1.4.1,1.9h-1.9ZM102.7,405.1c-1.6,0-3,.3-3,1.4s.5,1.1,1.2,1.1,1.5-.6,1.7-1.1c0-.1,0-.3,0-.4v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107,397.4h2.1v11.5h-2.1v-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3,397.4h2.1v11.5h-2.1v-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.8,404.9c0,2.8-2.1,4.2-4.4,4.2s-4.3-1.6-4.3-4,1.8-4.2,4.4-4.2,4.2,1.7,4.2,4ZM117.3,405c0,1.6.9,2.6,2.2,2.6s2.2-.9,2.2-2.6-.7-2.6-2.2-2.6-2.2,1.3-2.2,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.6,401.1l.9,3.5c.2.8.4,1.7.6,2.6h0c.2-.9.4-1.7.7-2.5l1.1-3.5h1.7l1,3.4c.3.9.5,1.8.7,2.6h0c.1-.9.3-1.7.6-2.6l.9-3.4h2l-2.6,7.8h-2l-1-3.2c-.3-.8-.4-1.6-.7-2.5h0c-.2,1-.4,1.7-.6,2.5l-1.1,3.2h-2l-2.4-7.8h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.9,408.9v-.9h-.2c-.5.6-1.4,1.1-2.5,1.1-1.7,0-2.6-1.2-2.6-2.3,0-2,1.8-3,5-3h0c0-.5-.2-1.5-1.7-1.5s-1.7.3-2.3.6l-.4-1.3c.7-.4,1.7-.7,3-.7,2.7,0,3.4,1.6,3.4,3.4v2.7c0,.7,0,1.4.1,1.9h-1.9ZM142.6,405.1c-1.6,0-3,.3-3,1.4s.5,1.1,1.2,1.1,1.5-.6,1.7-1.1c0-.1,0-.3,0-.4v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,401.1l1.6,4.2c.2.5.4,1.1.5,1.5h0c.1-.4.3-1.1.5-1.6l1.4-4.1h2.2l-2.1,5.2c-1.3,3.3-2.1,4.5-3,5.2-.8.7-1.7.9-2.2.9l-.4-1.7c.3,0,.8-.2,1.2-.4.4-.2.9-.7,1.2-1.3,0-.1.1-.2.1-.3s0-.2-.1-.4l-3.1-7.1h2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.4,408.9c-.3-.3-.6-.6-.9-.9-.9.7-1.9,1.1-3.3,1.1-2.6,0-3.8-1.5-3.8-3.1s.9-2.5,2.2-3.2h0c-.5-.6-.9-1.4-.9-2.1,0-1.3,1-2.8,3.2-2.8s2.8,1,2.8,2.4-.7,2.1-2.4,2.8h0c.8,1,1.7,1.9,2.3,2.5.5-.7.9-1.6,1.1-2.9h1.9c-.3,1.7-.9,3.1-1.8,4.1.7.8,1.3,1.4,2,2.1h-2.4ZM164.4,406.8c-.6-.6-1.7-1.7-2.9-3-.6.3-1.2.9-1.2,1.8s.8,1.9,2.1,1.9,1.5-.3,2-.7ZM161.5,400.5c0,.6.3,1.2.8,1.7,1-.6,1.6-1,1.6-1.8s-.4-1.2-1.2-1.2-1.2.6-1.2,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1,417.4c.8-.1,2-.2,3.3-.2s2.8.3,3.6.9c.6.5,1,1.2,1,2.2,0,1.4-1.1,2.4-2,2.7h0c.8.4,1.3,1.1,1.6,2.1.4,1.4.7,2.6.9,3.1h-2.1c-.2-.3-.4-1.2-.8-2.5-.4-1.4-.9-1.9-2.1-1.9h-1.2v4.4h-2v-10.6ZM90.1,422.2h1.4c1.4,0,2.3-.7,2.3-1.7s-1-1.7-2.3-1.7-1.2,0-1.4.1v3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,424.1c0,2.8-2.1,4.2-4.4,4.2s-4.3-1.6-4.3-4,1.8-4.2,4.4-4.2,4.2,1.7,4.2,4ZM99.4,424.2c0,1.6.9,2.6,2.2,2.6s2.2-.9,2.2-2.6-.7-2.6-2.2-2.6-2.2,1.3-2.2,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.6,416.6v9.3c0,.8,0,1.7,0,2.2h-1.8v-1.3h-.1c-.5,1-1.6,1.5-2.8,1.5-2,0-3.6-1.6-3.6-4,0-2.6,1.8-4.2,3.8-4.2s2.1.5,2.5,1.1h0v-4.5h2ZM113.5,423.6c0-.2,0-.4,0-.5-.2-.8-.9-1.5-1.9-1.5s-2.2,1.1-2.2,2.5.8,2.4,2.2,2.4,1.8-.7,2-1.6c0-.2,0-.4,0-.6v-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.3,424.7c0,1.3,1.2,2,2.6,2s1.7-.1,2.4-.4l.3,1.4c-.7.3-1.7.5-3,.5-2.7,0-4.3-1.6-4.3-4s1.3-4.2,4.1-4.2,3.6,2.3,3.6,3.9,0,.6,0,.8h-5.7ZM123.2,423.3c0-.5-.3-1.9-1.8-1.9s-1.9,1.1-2,1.9h3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140,427.5c-.8.3-2.3.7-3.9.7s-3.6-.5-4.7-1.6c-1-.9-1.6-2.3-1.6-3.8,0-3.2,2.5-5.6,6.6-5.6s2.7.3,3.3.6l-.5,1.6c-.7-.3-1.5-.5-2.9-.5-2.6,0-4.3,1.5-4.3,3.8s1.6,3.9,4.2,3.9,1.5-.1,1.8-.3v-2.6h-2.1v-1.6h4.2v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.6,424.7c0,1.3,1.2,2,2.6,2s1.7-.1,2.4-.4l.3,1.4c-.7.3-1.7.5-3,.5-2.7,0-4.3-1.6-4.3-4s1.3-4.2,4.1-4.2,3.6,2.3,3.6,3.9,0,.6,0,.8h-5.7ZM147.5,423.3c0-.5-.3-1.9-1.8-1.9s-1.9,1.1-2,1.9h3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.7,425.7c0,.9,0,1.7,0,2.4h-1.8v-1.3h-.1c-.3.6-1.2,1.5-2.8,1.5s-2.9-.8-2.9-3.5v-4.5h2.1v4.1c0,1.4.5,2.2,1.6,2.2s1.5-.6,1.7-1.2c0-.2.1-.4.1-.6v-4.6h2.1v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.9,426.2c.5.3,1.4.6,2.2.6s1.3-.4,1.3-.9-.4-.8-1.4-1.1c-1.6-.5-2.4-1.3-2.4-2.3,0-1.4,1.2-2.5,3.2-2.5s1.8.2,2.3.5l-.4,1.4c-.3-.2-1.1-.5-1.8-.5s-1.2.3-1.2.8.4.8,1.5,1.1c1.5.4,2.2,1.2,2.2,2.4,0,1.4-1.1,2.5-3.4,2.5s-2-.2-2.6-.6l.4-1.5Z"
  }))), _g47 || (_g47 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st27",
    x: 3616.2,
    y: 615.6,
    width: 97.5,
    height: 112.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "3789 301.3 3778.8 289.9 3768.5 278.5 3789 278.5 3789 301.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3789 301.3 3778.8 289.9 3768.5 278.5 3789 278.5 3789 301.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "3748.5 415.7 3738.2 404.3 3727.9 392.8 3748.5 392.8 3748.5 415.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 3693.7,
    y: 153.4,
    width: 280,
    height: 240
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "3904.3 301.3 3894 289.9 3883.7 278.5 3904.3 278.5 3904.3 301.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "4032.1 415.7 4021.8 404.3 4011.5 392.8 4032.1 392.8 4032.1 415.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 3973.7,
    y: 153.4,
    width: 280,
    height: 240
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "4188.9 301.3 4178.7 289.9 4168.4 278.5 4188.9 278.5 4188.9 301.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    x: 4393.6,
    y: 153.4,
    width: 60,
    height: 240
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "4296.1 415.7 4285.8 404.3 4275.5 392.8 4296.1 392.8 4296.1 415.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 4253.6,
    y: 153.4,
    width: 140,
    height: 240
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "4331 301.3 4320.7 289.9 4310.4 278.5 4331 278.5 4331 301.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st27",
    x: 3593.7,
    y: 727.7,
    width: 42,
    height: 102
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 4533.7,
    y1: 1473.2,
    x2: 4533.7,
    y2: 923.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 4533.6,
    y1: 646.7,
    x2: 4533.6,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("text", {
    className: "st6",
    transform: "translate(3609.6 746.6) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "INGANG")), /*#__PURE__*/React.createElement("rect", {
    className: "st31",
    x: 3713.7,
    y: 587.3,
    width: 20,
    height: 140
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st31",
    x: 3713.7,
    y: 830.1,
    width: 20,
    height: 143.1
  }), /*#__PURE__*/React.createElement("text", {
    className: "st13",
    transform: "translate(3627.9 668)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "REGISTRATIE/"), /*#__PURE__*/React.createElement("tspan", {
    x: 2.7,
    y: 14.5
  }, "INFORMATIE"), /*#__PURE__*/React.createElement("tspan", {
    x: 21.4,
    y: 29.1
  }, "BALIE")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-21",
    "data-name": "stand-2",
    className: "st26",
    x: 3854.7,
    y: 1013.4,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    id: "stand-41",
    "data-name": "stand-4",
    className: "st26",
    x: 4013.8,
    y: 1013.4,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    id: "stand-51",
    "data-name": "stand-5",
    className: "st26",
    x: 4093.7,
    y: 1013.4,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st29",
    x: 4254.4,
    y: 688.4,
    width: 200,
    height: 100
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 5333.7,
    y1: 73.1,
    x2: 5333.7,
    y2: 1019.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 4534.3,
    y: 1073.4,
    width: 800,
    height: 400
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 4534.3,
    y: 73.4,
    width: 800,
    height: 400
  }), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1272",
    "data-name": "stand-127",
    className: "st28",
    x: 3734.7,
    y: 903.2,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3763.6 955.5) rotate(-90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "128")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12813",
    "data-name": "stand-128",
    className: "st28",
    x: 4647,
    y: 1014.9,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4656.4 1042.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "130")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12814",
    "data-name": "stand-128",
    className: "st28",
    x: 4707,
    y: 1014.9,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4716.4 1042.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "131")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12815",
    "data-name": "stand-128",
    className: "st22",
    x: 4936.4,
    y: 1014.9,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4945.8 1042.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "138")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1262",
    "data-name": "stand-126",
    className: "st28",
    x: 3734.7,
    y: 842.8,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3763.6 894) rotate(-90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "127")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1273",
    "data-name": "stand-127",
    className: "st28",
    x: 3734.7,
    y: 659.9,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3763.6 712.3) rotate(-90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "106")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1263",
    "data-name": "stand-126",
    className: "st28",
    x: 3734.7,
    y: 599.5,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3763.6 650.8) rotate(-90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "105")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-1141",
    "data-name": "stand-114",
    className: "st28",
    x: 3834.7,
    y: 830.1,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3844.1 858.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "117"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-1191",
    "data-name": "stand-119",
    className: "st28",
    x: 3834.7,
    y: 870.1,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3844.1 897.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "122"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-1081",
    "data-name": "stand-108",
    className: "st28",
    x: 4154.7,
    y: 646.7,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4164.1 674)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "111"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-1131",
    "data-name": "stand-113",
    className: "st28",
    x: 4154.7,
    y: 686.7,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4164.1 714)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "116"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-11",
    "data-name": "stand-1",
    className: "st26",
    x: 3774.7,
    y: 1013.4,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3806.6 1051.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1"))), /*#__PURE__*/React.createElement("rect", {
    id: "stand-141",
    "data-name": "stand-14",
    className: "st26",
    x: 4333.8,
    y: 506.7,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4360.1 544)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "17")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-151",
    "data-name": "stand-15",
    className: "st26",
    x: 4253.8,
    y: 506.7,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4280.1 544)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "18")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-162",
    "data-name": "stand-16",
    className: "st26",
    x: 4173.7,
    y: 506.7,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4200 544)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "19")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-173",
    "data-name": "stand-17",
    className: "st26",
    x: 4093.7,
    y: 506.7,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4120 544)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "20")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-174",
    "data-name": "stand-17",
    className: "st26",
    x: 4013.8,
    y: 506.7,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4040.1 544)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "21")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-163",
    "data-name": "stand-16",
    className: "st26",
    x: 4584.4,
    y: 763.1,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4610.6 800.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "23")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-175",
    "data-name": "stand-17",
    className: "st26",
    x: 4584.4,
    y: 703.1,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4610.6 740.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "22")), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3887.8 1051.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-31",
    "data-name": "stand-3",
    className: "st26",
    x: 3934.7,
    y: 1013.4,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3967.8 1051.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4047 1051.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4126.2 1051.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5")), /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(4314 743.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CATERING")), /*#__PURE__*/React.createElement("rect", {
    className: "st29",
    x: 5046.6,
    y: 672.1,
    width: 115,
    height: 143.4
  }), /*#__PURE__*/React.createElement("text", {
    className: "st7",
    transform: "translate(5063.7 748.9)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CATERING")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1151",
    "data-name": "stand-115",
    className: "st28",
    x: 3914.7,
    y: 830.1,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1171",
    "data-name": "stand-117",
    className: "st28",
    x: 4074.7,
    y: 830.1,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1201",
    "data-name": "stand-120",
    className: "st28",
    x: 3914.7,
    y: 870.1,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1231",
    "data-name": "stand-123",
    className: "st28",
    x: 4154.7,
    y: 869.2,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3923.9 858.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "118")), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3924.1 897.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "123")), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4084.6 858.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "120")), /*#__PURE__*/React.createElement("g", {
    id: "stand-1241",
    "data-name": "stand-124"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st28",
    x: 4074.7,
    y: 870.1,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4084.1 897.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "125"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-1181",
    "data-name": "stand-118",
    className: "st28",
    x: 4154.7,
    y: 830.1,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4164.1 857.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "121"))), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1061",
    "data-name": "stand-106",
    className: "st28",
    x: 3994.7,
    y: 646.7,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4004.1 674)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "109")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-1111",
    "data-name": "stand-111",
    className: "st28",
    x: 3994.7,
    y: 686.7,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4004.1 714)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "114"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-1161",
    "data-name": "stand-116",
    className: "st28",
    x: 3994.7,
    y: 830.1,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4004.1 857.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "119"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-2064",
    "data-name": "stand-206",
    className: "st22",
    x: 4876.4,
    y: 1014.9,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4885.8 1042.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "137"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-2065",
    "data-name": "stand-206",
    className: "st28",
    x: 4535.1,
    y: 923.3,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4547.8 932.7) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "129"))), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12816",
    "data-name": "stand-128",
    className: "st22",
    x: 5054.1,
    y: 1014.9,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(5063.5 1042.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "140")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12817",
    "data-name": "stand-128",
    className: "st22",
    x: 5115,
    y: 1014.9,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(5124.4 1042.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "141")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12818",
    "data-name": "stand-128",
    className: "st22",
    x: 5174.1,
    y: 1015.1,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(5183.5 1042.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "142")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12819",
    "data-name": "stand-128",
    className: "st22",
    x: 5241.4,
    y: 920.6,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(5254.2 930) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "143")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-2066",
    "data-name": "stand-206",
    className: "st22",
    x: 4994.1,
    y: 1014.9,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(5003.5 1042.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "139"))), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12820",
    "data-name": "stand-128",
    className: "st28",
    x: 5241.4,
    y: 720.6,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(5254.2 730) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "134")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12821",
    "data-name": "stand-128",
    className: "st28",
    x: 5241.4,
    y: 779.5,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(5254.2 788.9) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "133")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12822",
    "data-name": "stand-128",
    className: "st28",
    x: 5241.4,
    y: 838.4,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(5254.2 847.8) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "132")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12823",
    "data-name": "stand-128",
    className: "st28",
    x: 5241.4,
    y: 602,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(5254.2 611.4) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "136")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12824",
    "data-name": "stand-128",
    className: "st28",
    x: 3755.9,
    y: 506.9,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3765.3 534.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "101")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-12825",
    "data-name": "stand-128",
    className: "st28",
    x: 3816.8,
    y: 506.9,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3826.2 534.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "102")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-2067",
    "data-name": "stand-206",
    className: "st28",
    x: 5241.4,
    y: 661.7,
    width: 40,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(5254.2 671.1) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "135"))), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1211",
    "data-name": "stand-121",
    className: "st28",
    x: 3994.7,
    y: 870.1,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4004.1 897.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "124")), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4164.1 896.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "126")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-61",
    "data-name": "stand-6",
    className: "st26",
    x: 4173.7,
    y: 1013.4,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("rect", {
    id: "stand-71",
    "data-name": "stand-7",
    className: "st26",
    x: 4253.7,
    y: 1013.4,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4206.9 1051.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "6")), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4286.2 1051.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")), /*#__PURE__*/React.createElement("g", {
    id: "stand-91",
    "data-name": "stand-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st26",
    x: 4473.7,
    y: 923.4,
    width: 60,
    height: 80
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4496.9 970.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "9"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3011",
    "data-name": "stand-301",
    className: "st21",
    x: 4254.7,
    y: 830.1,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(4258.1 856)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "201"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3041",
    "data-name": "stand-304",
    className: "st21",
    x: 4254.7,
    y: 870.1,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(4258.1 896)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "204"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3021",
    "data-name": "stand-302",
    className: "st21",
    x: 4334.7,
    y: 830.1,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(4338.1 856)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "202"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3051",
    "data-name": "stand-305",
    className: "st21",
    x: 4334.7,
    y: 870.1,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(4338.1 896)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "205"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3035",
    "data-name": "stand-303",
    className: "st21",
    x: 4414.4,
    y: 830.1,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(4417.7 856)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "203"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3065",
    "data-name": "stand-306",
    className: "st21",
    x: 4414.4,
    y: 870.1,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(4417.7 896)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "206"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3036",
    "data-name": "stand-303",
    className: "st21",
    x: 5054.1,
    y: 892.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(5057.4 918.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "213"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3066",
    "data-name": "stand-306",
    className: "st21",
    x: 5094.1,
    y: 892.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(5097.4 918.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "214"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3037",
    "data-name": "stand-303",
    className: "st21",
    x: 4917.7,
    y: 892.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(4921.1 918.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "211"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3067",
    "data-name": "stand-306",
    className: "st21",
    x: 4957.7,
    y: 892.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(4961.1 918.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "212"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3038",
    "data-name": "stand-303",
    className: "st21",
    x: 4780.3,
    y: 892.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(4783.7 918.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "209"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3068",
    "data-name": "stand-306",
    className: "st21",
    x: 4820.3,
    y: 892.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(4823.7 918.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "210"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3039",
    "data-name": "stand-303",
    className: "st18",
    x: 4647,
    y: 892.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(4650.4 918.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "207"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-3069",
    "data-name": "stand-306",
    className: "st18",
    x: 4687,
    y: 892.8,
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st10",
    transform: "translate(4690.4 918.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "208"))), /*#__PURE__*/React.createElement("g", {
    className: "st36"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st34"
  }, /*#__PURE__*/React.createElement("image", {
    width: 627,
    height: 576,
    transform: "translate(5183 465.3) rotate(45.1) scale(.1)",
    xlinkHref: "Waterinfodag-Plattegrond-2026-3-1.png"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "st5",
    transform: "translate(5102.6 554.6)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PITCH"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.2,
    y: 21.2
  }, "THEATER ")), /*#__PURE__*/React.createElement("g", {
    className: "st35"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st39"
  }, /*#__PURE__*/React.createElement("image", {
    width: 627,
    height: 576,
    transform: "translate(4813 1210.2) rotate(90.1) scale(.2)",
    xlinkHref: "Waterinfodag-Plattegrond-2026-3-2.png"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(4644 1259.4)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "STREAM"), /*#__PURE__*/React.createElement("tspan", {
    x: -3.8,
    y: 23.6
  }, "THEATER")), /*#__PURE__*/React.createElement("g", {
    className: "st38"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st37"
  }, /*#__PURE__*/React.createElement("image", {
    width: 627,
    height: 576,
    transform: "translate(5207.9 1210.2) rotate(90.1) scale(.2)",
    xlinkHref: "Waterinfodag-Plattegrond-2026-3-3.png"
  }))), /*#__PURE__*/React.createElement("text", {
    className: "st9",
    transform: "translate(4968.8 1251)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRESENTATIES"), /*#__PURE__*/React.createElement("tspan", {
    x: -12.4,
    y: 23.6
  }, "KENNISCENTRUM"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.9,
    y: 47.2
  }, "MICROSOFT")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-81",
    "data-name": "stand-8",
    className: "st26",
    x: 4333.7,
    y: 1013.4,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4366.2 1051.8)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "8")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-121",
    "data-name": "stand-12",
    className: "st26",
    x: 4621.7,
    y: 474.4,
    width: 120,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4667.9 511.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "14"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-112",
    "data-name": "stand-11",
    className: "st26",
    x: 4741.7,
    y: 474.4,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4767.9 511.7)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "13"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-113",
    "data-name": "stand-11",
    className: "st26",
    x: 4534.4,
    y: 566.7,
    width: 60,
    height: 80
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4550.6 614)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "15"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-103",
    "data-name": "stand-10",
    className: "st26",
    x: 4821.7,
    y: 474.2,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4847 512.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "12"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-104",
    "data-name": "stand-10",
    className: "st26",
    x: 4901.7,
    y: 474.2,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4927 512.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "11"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-105",
    "data-name": "stand-10",
    className: "st26",
    x: 4981.7,
    y: 474.2,
    width: 80,
    height: 60
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(5007 512)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    x: 4741.7,
    y: 666.7,
    width: 200,
    height: 160
  }), /*#__PURE__*/React.createElement("text", {
    className: "st33",
    transform: "translate(4764.8 721.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ONTMOETINGSPLEIN"), /*#__PURE__*/React.createElement("tspan", {
    x: -14.7,
    y: 20.3,
    xmlSpace: "preserve"
  }, "HET  WATERSCHAPSHUIS"), /*#__PURE__*/React.createElement("tspan", {
    x: -15.4,
    y: 40.5
  }, "INFORMATIEHUIS WATER"), /*#__PURE__*/React.createElement("tspan", {
    x: 49.4,
    y: 60.8
  }, "STOWA"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st16",
    x: 4533.6,
    y: 1003.4,
    width: 86.8,
    height: 69.4
  }), /*#__PURE__*/React.createElement("text", {
    className: "st32",
    transform: "translate(4566.3 1033.3)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VR "), /*#__PURE__*/React.createElement("tspan", {
    x: -20,
    y: 18.6
  }, "THEATER"))), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1011",
    "data-name": "stand-101",
    className: "st28",
    x: 3876.8,
    y: 506.9,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3886.2 534.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "103")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1021",
    "data-name": "stand-102",
    className: "st28",
    x: 3937.1,
    y: 506.7,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3946.6 534)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "104")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-131",
    "data-name": "stand-13",
    className: "st26",
    x: 4473.7,
    y: 566.7,
    width: 60,
    height: 80
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4490 614)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "16")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1071",
    "data-name": "stand-107",
    className: "st28",
    x: 4074.7,
    y: 646.7,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4084.1 674)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "110")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-1121",
    "data-name": "stand-112",
    className: "st28",
    x: 4074.7,
    y: 686.7,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(4084.1 714)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "115"))), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1051",
    "data-name": "stand-105",
    className: "st28",
    x: 3914.7,
    y: 646.7,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1101",
    "data-name": "stand-110",
    className: "st28",
    x: 3914.7,
    y: 686.7,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3923.9 675.2)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "108")), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3924.1 714)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "113")), /*#__PURE__*/React.createElement("rect", {
    id: "stand-1091",
    "data-name": "stand-109",
    className: "st28",
    x: 3834.7,
    y: 686.7,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "stand-1041",
    "data-name": "stand-104",
    className: "st28",
    x: 3834.7,
    y: 646.7,
    width: 60,
    height: 40
  }), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3844.1 674)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "107"))), /*#__PURE__*/React.createElement("text", {
    className: "st14",
    transform: "translate(3844.1 714)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "112")), /*#__PURE__*/React.createElement("rect", {
    id: "Omtrek_beide_hallen1",
    "data-name": "Omtrek_beide_hallen",
    className: "st2",
    x: 3593.7,
    y: 73.2,
    width: 1740,
    height: 1400
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 3709.5,
    y: 235.4,
    width: 248.4,
    height: 76
  }), /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(3775.7 280.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEXTER 11"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 3989.5,
    y: 235.4,
    width: 248.4,
    height: 76
  }), /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(4055.7 280.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEXTER 15"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 4261,
    y: 235.4,
    width: 125.3,
    height: 76
  }), /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(4279 266.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEXTER "), /*#__PURE__*/React.createElement("tspan", {
    x: 31.3,
    y: 28.8
  }, "19"))), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "3789 1301.4 3778.8 1289.9 3768.5 1278.5 3789 1278.5 3789 1301.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "3789 1301.4 3778.8 1289.9 3768.5 1278.5 3789 1278.5 3789 1301.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "3759.9 1130.6 3770.2 1142 3780.5 1153.4 3759.9 1153.4 3759.9 1130.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 3721.5,
    y: 1153.4,
    width: 280,
    height: 240
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "3931 1301.4 3920.7 1289.9 3910.4 1278.5 3931 1278.5 3931 1301.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "4045.1 1130.6 4055.4 1142 4065.7 1153.4 4045.1 1153.4 4045.1 1130.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 4001.5,
    y: 1153.4,
    width: 280,
    height: 240
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "4215.7 1301.4 4205.4 1289.9 4195.1 1278.5 4215.7 1278.5 4215.7 1301.4"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st17",
    x: 4420.4,
    y: 1153.4,
    width: 60,
    height: 240
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "4293.1 1130.6 4303.4 1142 4313.7 1153.4 4293.1 1153.4 4293.1 1130.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "st20",
    x: 4281.5,
    y: 1153.4,
    width: 140,
    height: 240
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st20",
    points: "4357.7 1301.4 4347.5 1289.9 4337.2 1278.5 4357.7 1278.5 4357.7 1301.4"
  }), /*#__PURE__*/React.createElement("text", {
    className: "st4",
    transform: "translate(4636.8 1142)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "10.00 - 11.00 UUR PLENAIRE OPENING")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 3737.3,
    y: 1235.4,
    width: 248.4,
    height: 76
  }), /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(3803.4 1280.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEXTER 22"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 4017.3,
    y: 1235.4,
    width: 248.4,
    height: 76
  }), /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(4083.4 1280.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEXTER 26"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "st24",
    x: 4289.1,
    y: 1235.4,
    width: 125.3,
    height: 76
  }), /*#__PURE__*/React.createElement("text", {
    className: "st8",
    transform: "translate(4307.1 1266.1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "DEXTER "), /*#__PURE__*/React.createElement("tspan", {
    x: 31.3,
    y: 28.8
  }, "30"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 3610.2,
    y1: 456.8,
    x2: 3652.1,
    y2: 456.8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "3613.1 466.7 3595.9 456.8 3613.1 446.8 3613.1 466.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 4826.4,
    y1: 1058.4,
    x2: 4826.4,
    y2: 1016.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "4836.3 1055.5 4826.4 1072.8 4816.4 1055.5 4836.3 1055.5"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 3604.6,
    y1: 454.9,
    x2: 3605.9,
    y2: 454.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M3667.9,451.6c-.8.3-2.3.7-3.9.7s-3.6-.5-4.7-1.6c-1-.9-1.6-2.3-1.6-3.8,0-3.2,2.5-5.6,6.6-5.6s2.7.3,3.3.6l-.5,1.6c-.7-.3-1.5-.5-2.9-.5-2.6,0-4.3,1.5-4.3,3.8s1.6,3.9,4.2,3.9,1.5-.1,1.8-.3v-2.6h-2.1v-1.6h4.2v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3674.9,452.1v-.9h-.2c-.5.6-1.4,1.1-2.5,1.1-1.7,0-2.6-1.2-2.6-2.3,0-2,1.8-3,5-3h0c0-.5-.2-1.5-1.7-1.5s-1.7.3-2.3.6l-.4-1.3c.7-.4,1.7-.7,3-.7,2.7,0,3.4,1.6,3.4,3.4v2.7c0,.7,0,1.4.1,1.9h-1.9ZM3674.6,448.3c-1.6,0-3,.3-3,1.4s.5,1.1,1.2,1.1,1.5-.6,1.7-1.1c0-.1,0-.3,0-.4v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3678.9,440.7h2.1v11.5h-2.1v-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3683.3,440.7h2.1v11.5h-2.1v-11.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3695.7,448.1c0,2.8-2.1,4.2-4.4,4.2s-4.3-1.6-4.3-4,1.8-4.2,4.4-4.2,4.2,1.7,4.2,4ZM3689.2,448.2c0,1.6.9,2.6,2.2,2.6s2.2-.9,2.2-2.6-.7-2.6-2.2-2.6-2.2,1.3-2.2,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3698.5,444.3l.9,3.5c.2.8.4,1.7.6,2.6h0c.2-.9.4-1.7.7-2.5l1.1-3.5h1.7l1,3.4c.3.9.5,1.8.7,2.6h0c.1-.9.3-1.7.6-2.6l.9-3.4h2l-2.6,7.8h-2l-1-3.2c-.3-.8-.4-1.6-.7-2.5h0c-.2,1-.4,1.7-.6,2.5l-1.1,3.2h-2l-2.4-7.8h2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3714.8,452.1v-.9h-.2c-.5.6-1.4,1.1-2.5,1.1-1.7,0-2.6-1.2-2.6-2.3,0-2,1.8-3,5-3h0c0-.5-.2-1.5-1.7-1.5s-1.7.3-2.3.6l-.4-1.3c.7-.4,1.7-.7,3-.7,2.7,0,3.4,1.6,3.4,3.4v2.7c0,.7,0,1.4.1,1.9h-1.9ZM3714.6,448.3c-1.6,0-3,.3-3,1.4s.5,1.1,1.2,1.1,1.5-.6,1.7-1.1c0-.1,0-.3,0-.4v-1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3719.9,444.3l1.6,4.2c.2.5.4,1.1.5,1.5h0c.1-.4.3-1.1.5-1.6l1.4-4.1h2.2l-2.1,5.2c-1.3,3.3-2.1,4.5-3,5.2-.8.7-1.7.9-2.2.9l-.4-1.7c.3,0,.8-.2,1.2-.4.4-.2.9-.7,1.2-1.3,0-.1.1-.2.1-.3s0-.2-.1-.4l-3.1-7.1h2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3738.3,452.1c-.3-.3-.6-.6-.9-.9-.9.7-1.9,1.1-3.3,1.1-2.6,0-3.8-1.5-3.8-3.1s.9-2.5,2.2-3.2h0c-.5-.6-.9-1.4-.9-2.1,0-1.3,1-2.8,3.2-2.8s2.8,1,2.8,2.4-.7,2.1-2.4,2.8h0c.8,1,1.7,1.9,2.3,2.5.5-.7.9-1.6,1.1-2.9h1.9c-.3,1.7-.9,3.1-1.8,4.1.7.8,1.3,1.4,2,2.1h-2.4ZM3736.3,450.1c-.6-.6-1.7-1.7-2.9-3-.6.3-1.2.9-1.2,1.8s.8,1.9,2.1,1.9,1.5-.3,2-.7ZM3733.5,443.7c0,.6.3,1.2.8,1.7,1-.6,1.6-1,1.6-1.8s-.4-1.2-1.2-1.2-1.2.6-1.2,1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3660,460.7c.8-.1,2-.2,3.3-.2s2.8.3,3.6.9c.6.5,1,1.2,1,2.2,0,1.4-1.1,2.4-2,2.7h0c.8.4,1.3,1.1,1.6,2.1.4,1.4.7,2.6.9,3.1h-2.1c-.2-.3-.4-1.2-.8-2.5-.4-1.4-.9-1.9-2.1-1.9h-1.2v4.4h-2v-10.6ZM3662.1,465.4h1.4c1.4,0,2.3-.7,2.3-1.7s-1-1.7-2.3-1.7-1.2,0-1.4.1v3.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3677.9,467.3c0,2.8-2.1,4.2-4.4,4.2s-4.3-1.6-4.3-4,1.8-4.2,4.4-4.2,4.2,1.7,4.2,4ZM3671.4,467.4c0,1.6.9,2.6,2.2,2.6s2.2-.9,2.2-2.6-.7-2.6-2.2-2.6-2.2,1.3-2.2,2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3687.5,459.9v9.3c0,.8,0,1.7,0,2.2h-1.8v-1.3h-.1c-.5,1-1.6,1.5-2.8,1.5-2,0-3.6-1.6-3.6-4,0-2.6,1.8-4.2,3.8-4.2s2.1.5,2.5,1.1h0v-4.5h2ZM3685.5,466.9c0-.2,0-.4,0-.5-.2-.8-.9-1.5-1.9-1.5s-2.2,1.1-2.2,2.5.8,2.4,2.2,2.4,1.8-.7,2-1.6c0-.2,0-.4,0-.6v-.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3691.2,468c0,1.3,1.2,2,2.6,2s1.7-.1,2.4-.4l.3,1.4c-.7.3-1.7.5-3,.5-2.7,0-4.3-1.6-4.3-4s1.3-4.2,4.1-4.2,3.6,2.3,3.6,3.9,0,.6,0,.8h-5.7ZM3695.1,466.6c0-.5-.3-1.9-1.8-1.9s-1.9,1.1-2,1.9h3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3712,470.8c-.8.3-2.3.7-3.9.7s-3.6-.5-4.7-1.6c-1-.9-1.6-2.3-1.6-3.8,0-3.2,2.5-5.6,6.6-5.6s2.7.3,3.3.6l-.5,1.6c-.7-.3-1.5-.5-2.9-.5-2.6,0-4.3,1.5-4.3,3.8s1.6,3.9,4.2,3.9,1.5-.1,1.8-.3v-2.6h-2.1v-1.6h4.2v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3715.6,468c0,1.3,1.2,2,2.6,2s1.7-.1,2.4-.4l.3,1.4c-.7.3-1.7.5-3,.5-2.7,0-4.3-1.6-4.3-4s1.3-4.2,4.1-4.2,3.6,2.3,3.6,3.9,0,.6,0,.8h-5.7ZM3719.4,466.6c0-.5-.3-1.9-1.8-1.9s-1.9,1.1-2,1.9h3.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3730.6,469c0,.9,0,1.7,0,2.4h-1.8v-1.3h-.1c-.3.6-1.2,1.5-2.8,1.5s-2.9-.8-2.9-3.5v-4.5h2.1v4.1c0,1.4.5,2.2,1.6,2.2s1.5-.6,1.7-1.2c0-.2.1-.4.1-.6v-4.6h2.1v5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3732.8,469.5c.5.3,1.4.6,2.2.6s1.3-.4,1.3-.9-.4-.8-1.4-1.1c-1.6-.5-2.4-1.3-2.4-2.3,0-1.4,1.2-2.5,3.2-2.5s1.8.2,2.3.5l-.4,1.4c-.3-.2-1.1-.5-1.8-.5s-1.2.3-1.2.8.4.8,1.5,1.1c1.5.4,2.2,1.2,2.2,2.4,0,1.4-1.1,2.5-3.4,2.5s-2-.2-2.6-.6l.4-1.5Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterinfodagPlattegrond2026);
export default __webpack_public_path__ + "static/media/Waterinfodag-Plattegrond-2026.e34e59184fb6ab48ec139de375f3f3fa.svg";
export { ForwardRef as ReactComponent };